import { X, Mail, Instagram, Music, Disc3 } from 'lucide-react';
import logo from './assets/logo.png';
import wings from './assets/wings.png';
import wings2 from './assets/wings2.png';
import moth from './assets/moth.png';
import chenille from './assets/chenille.png';
import './index.css';
import genscoFont from './fonts/Gensco.otf';
import florRuina from './fonts/FlorDeRuina-Flor.woff2';
import basteleurReg from './fonts/Basteleur-Bold.woff2';
import karrikReg from './fonts/Karrik-Regular.woff2';
import wingSfx from './assets/sounds/heaven.mp3';
import evilSfx from './assets/sounds/mystere.mp3';
import maPhoto from './assets/artistpic.webp';
import React, { useEffect, useState } from "react";

//Projet 1 : Boulevard
import boul1 from './assets/photos/brokendreamz1.webp';
import boul2 from './assets/photos/brokendreamz2.webp';
import boul3 from './assets/photos/brokendreamz3.webp';
import boul4 from './assets/photos/brokendreamz4.webp';
import boul5 from './assets/photos/brokendreamz5.webp';
import boul6 from './assets/photos/brokendreamz6.webp';

// Projet 2: Vengeance
import v1 from './assets/photos/vengeance1.webp';
import v2 from './assets/photos/vengeance2.webp';
import v3 from './assets/photos/vengeance3.webp';
import v4 from './assets/photos/vengeance4.webp';
import v5 from './assets/photos/vengeance5.webp';

// Projet 3: Amygdala
import s2 from './assets/photos/sigma2.webp';
import s3 from './assets/photos/sigma3.webp';
import s4 from './assets/photos/sigma4.webp';
import s5 from './assets/photos/sigma5.webp';
import s6 from './assets/photos/sigma6.webp';
import s7 from './assets/photos/sigma7.webp';
import s8 from './assets/photos/sigma8.webp';
import s9 from './assets/photos/sigma9.webp';

// Projet 4: Buggin
import b1 from './assets/photos/buggin1.webp';
import b2 from './assets/photos/buggin2.webp';
import b3 from './assets/photos/buggin3.webp';
import b4 from './assets/photos/buggin4.webp';
import b5 from './assets/photos/buggin5.webp';
import b6 from './assets/photos/buggin6.webp';
import b7 from './assets/photos/buggin7.webp';
import b8 from './assets/photos/buggin8.webp';

// Projet 5: Dialing
import d1 from './assets/photos/dialing1.webp';
import d2 from './assets/photos/dialing2.webp';

// Projet 6: Liberty
import l1 from './assets/photos/liberty1.webp';
import l2 from './assets/photos/liberty2.webp';
import l3 from './assets/photos/liberty3.webp';
import l4 from './assets/photos/liberty4.webp';

// Projet 7: Croco
import c1 from './assets/photos/croco1.webp';
import c2 from './assets/photos/croco2.webp';
import c3 from './assets/photos/croco3.webp';
import c4 from './assets/photos/croco4.webp';
import c5 from './assets/photos/croco5.webp';
import c6 from './assets/photos/croco6.webp';
import c7 from './assets/photos/croco7.webp';
import c8 from './assets/photos/croco8.webp';



// Projet 8: Hotwheels
import hot1 from './assets/photos/hotwheels1.webp';
import hot2 from './assets/photos/hotwheels2.webp';
import hot3 from './assets/photos/hotwheels3.webp';
import hot4 from './assets/photos/hotwheels4.webp';

// Projet 9: Punching ball
import punch1 from './assets/photos/punchingball2.webp';

// Projet 10: wallofnoize
import noise1 from './assets/photos/wallofnoize.webp'
import noise2 from './assets/photos/moto1.webp';
import noise3 from './assets/photos/nounours1.webp';
import noise4 from './assets/photos/puce1.webp';
import noise5 from './assets/photos/puce2.webp';
import noise6 from './assets/photos/souris1.webp';
import noise7 from './assets/photos/enquete1.webp';
import noise8 from './assets/photos/yahourt1.webp';

// Projet 11: traumachinepanneau
import panneau1 from './assets/photos/traumachine.webp';


// Projet 12: Alien
import alien1 from './assets/photos/alien1.webp';

// Données des projets - remplace par tes propres images et infos
const projects = [
{
    id: 1,
    title: "Méga Moderne : Boulevard of Broken Dreamz",
    year: "2026",
    dimensions: "20 x 15 m",
    materials: "Mixed media installation",
    thumbnail:boul1,
    images: [boul1, boul2, boul3, boul4, boul5, boul6],
    description: "Installation view at Arba-Esa. "
  },
  {
    id: 2,
    title: "You licked my wounds but all I wanted was vengeance",
    year: "2025",
    dimensions: "150 * 150 * 120 cm",
    materials: "Installation - Glazed stoneware, found objects",
    thumbnail: v1,
    images: [v1, v2, v3, v4, v5],
    description: "Installation view at Einblick, Ausblick (Kiel). "
  },
 {
    id: 3,
    title: "Amygdala, Epicenter of Fear",
    year: "2025",
    dimensions: "Variable dimensions",
    materials: "Installation - Glazed stoneware, steel, glass, sound",
    thumbnail: s2,
    images: [s2, s3, s4, s5, s6, s7, s8, s9],
    description: "Solo Show at ProjektRaum (Kiel). Sound link: https://soundcloud.com/tangurex/amygdala-epicenter-of-fear. The installation is comprised of the centerpiece 'Sigma, Alpha, Beta', five wall ceramics, and a digital sound piece."
  },
{
    id: 4,
    title: "Buggin' Around",
    year: "2025",
    dimensions: "Performance, 10 minutes, 4 times",
    materials: "Performance - Bike Helmets, Yoga Balls",
    thumbnail: b1,
    images: [b1, b2, b3, b4, b5, b6, b7, b8],
    description: "Performance played 4 times at Künstlerhaus Bethanien (Berlin), for the MONSTRUMZ exhibition. Written and performed by Tâm Nguyen in collaboration with Marie Borgerding, Lara Meise, and Ruth Pick. Dung beetle bike helmets made by Tâm Nguyen with the help of Ruth. In response to the collective performance MONSTRUMZ, which explored the 'banality of evil' through bureaucratic robotic rituals, worship of the printer, and the boredom and weariness of institutions—we staged a counter-intervention. While the bureaucrats occupied the space with stagnant, repetitive gestures of obedience, we hacked a biological and chaotic glitch into their system. Wearing dung beetle-shaped bike helmets and wielding large yoga balls, we transformed the sterile, holy administrative environment into an absurd and chaotic playground. We drew inspiration from the Egyptian Dung Beetle and Khepri in Ancient Egypt, the beetle rolling its ball of dung was a sacred metaphor for the movement of the sun across the sky. As small insects can find purpose in waste, we redefine the 'useless' task. We revived the ancient rhythm of the Sun-bearer, rolling the sphere not as a burden, but as a transcendental cosmic act of play. This counter-performance acted as the 'shaking of the system' mentioned in the exhibition’s premise."
  },
  {
    id: 5,
    title: "Dialing back our clocks one or two centuries",
    year: "2024",
    dimensions: "15 x 20 x 20 cm times two",
    materials: "Sculpture - Glazed Stoneware, found objects",
    thumbnail: d1,
    images: [d1, d2],
    description: "Putting children in jail. Exhibition view at FabrikStrasse (Kiel), for the exhibition Zwei Einheiten"
  },
  {
    id: 6,
    title: "Liberty my arse",
    year: "2025",
    dimensions: "120 x 120 x 300 cm",
    materials: "Installation - Plaster, Found object, rope",
    thumbnail: l4,
    images: [l4, l1, l3, l2],
    description: "Exhibition view at Kunstlerhaus Bethanien (Berlin), for the MONSTRUMZ exhibition . The statue of liberty head was bondaged in a classic shibari knot by Mr Red Donkey."
  },
 {
    id: 7,
    title: "The Wise Crocodile",
    year: "2024",
    dimensions: "Performance, 10 minutes",
    materials: "Performance - Glazed Stoneware",
    thumbnail: c1,
    images: [c1, c2, c3, c4, c5, c6, c7, c8],
    description: "Performance view at Ufer Studios (Berlin), for the Wolfstöne exhibition. This work explores the 'Wolf Tone' an acoustic parasite and harmonic interference as a metaphor for social and mythological 'disturbing noises.' In this exhibition we addressed the 'Wolf' not as a creature, but as a construct: a figure used to personify male violence and the predatory 'Alpha' archetype. To dismantle this aggression, I responded through a meditative soundpiece, where ceramic instruments are being used."
  },


  {
    id: 8,
    title: "Hotwheels",
    year: "2024",
    dimensions: "Installation - Format variable",
    materials: "Céramique, bave, pièces",
    thumbnail: hot1,
    images: [hot1, hot2, hot3, hot4],
    description: "vitesse. Exhibition view at Espace Vanderboght (Brussels)."
  },
  {
    id: 9,
    title: "Please Do Hit",
    year: "2023",
    dimensions: "60x60x200",
    materials: "Sculpture - Steel, punching ball, acrylics on wood",
    thumbnail: punch1,
    images: [punch1],
    description: "Exhibition view at Espace Vanderboght (Brussels)."
  },
  {
    id: 10,
    title: "Wall of noise",
    year: "2021-ongoing",
    dimensions: "",
    materials: "Paint on canvas",
    thumbnail: noise1,
    images: [noise1,noise2,noise3,noise4,noise5,noise6,noise7,noise8],
    description: "I have been developing this series of paintings since 2021. I’m trying to capture a sensory landscape of overflowing of low quality data blinding us off, where information becomes a narcotic, a chaotic layer of interference that leads to engineered stupidity and numbness. By assembling pop icons, poor images, meme references, my own photographic works and ideas coming from my mind, I aim to materialize the mental claustrophobia and the drowing of the population in its own signals. Throughout the years, these paintings have evolved into an atmospheric study for my broader mythology : a world buried under a mountain of plastic, pixels and non-sense, inspiring the screenplay i’m writing, Méga moderne."
  },

  {
    id: 11,
    title: "Traumachine",
    year: "2024",
    dimensions: "200 x 120 cm",
    materials: "Mixed Media on wood",
    thumbnail: panneau1,
    images: [panneau1],
    description: "."
  },

  {
    id: 17,
    title: "Mathematics",
    year: "2021",
    dimensions: "150 x 150 ",
    materials: "Paint on canvas",
    thumbnail: alien1,
    images: [alien1],
    description: "My first painting ever, i still love it to this day"
  }

];



function App() {
  const [init, setInit] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeSection, setActiveSection] = useState('work');
  const [showSplash, setShowSplash] = useState(true); 
  const [showBetterText, setShowBetterText] = useState(false);
  
  // Pour le texte quand tu cliques sur les anges
  const handleWingClick = () => {
    playWingSound(); // Joue le son
    setShowBetterText(true);
    setTimeout(() => {
    setShowBetterText(false);
  }, 2000); // Disparaît après 2 secondes
  };


  // Effet pour faire disparaître le splash
  React.useEffect(() => { 
    if (showSplash) {
      const timer = setTimeout(() => {
        setShowSplash(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showSplash]);

  // Pour jouer le son des anges
const playWingSound = () => {
  const audio = new Audio(wingSfx);
  audio.volume = 0.5; // Ajustez le volume (0.0 à 1.0)
  audio.play().catch(e => console.log("L'audio n'a pas pu démarrer :", e));
};

// Pour jouer le son démon
const playEvilSound = () => {
  const audio = new Audio(evilSfx);
  audio.volume = 0.7;
  audio.play().catch(e => console.log("L'audio n'a pas pu démarrer :", e));
};

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: "'Inter', sans-serif" }}>

               {/* message flippant */}
        {showSplash && (
          <div 
            className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center transition-opacity duration-2000"
            style={{ 
              animation: 'fadeOut 2s forwards',
              opacity: showSplash ? 1 : 0 
            }}
          >
            <h1 className="text-6xl gensco text-red-600">
              There's a sort of evil out there...
            </h1>
          </div>
        )}

        {/* message cool */}
          {showBetterText && (
            <div 
              className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
              style={{ 
                animation: 'fadeOut 2s forwards',
                backgroundColor: 'rgba(0,0,0,0.3)' // Un voile très léger
              }}
            >
              <h1 className="text-4xl gensco text-white text-center px-4 tracking-widest">
                You just made the world a tiny bit better...
              </h1>
            </div>
          )}


      <style>{`
    
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400&display=swap');
                        
                    
                      @keyframes cocoonOpen {
                0% { 
                  clip-path: circle(0% at 50% 50%); 
                  background: black; 
                }
                100% { 
                  clip-path: circle(150% at 50% 50%); 
                  background: transparent; 
                }
              }

              .cocoon-overlay {
                position: fixed;
                inset: 0;
                background: black;
                z-index: 100;
                /* 0.8s avec une courbe "expo" pour plus de punch */
                animation: cocoonOpen 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
              }

              /* Apparition du contenu : Presque instantanée après l'ouverture */
              .project-content {
                /* Le contenu attend seulement 0.2s */
                animation: fadeInContent 0.6s ease-out 0.2s forwards;
                opacity: 0;
              }

              @keyframes fadeInContent {
                from { 
                  opacity: 0; 
                  transform: scale(0.95); 
                }
                to { 
                  opacity: 1; 
                  transform: scale(1); 
                }
              }



            @keyframes breathe {
              0% { transform: scale(1); }
              50% { transform: scale(1.03); } /* Grossit très légèrement */
              100% { transform: scale(1); }
            }

            .breathing-logo {
              animation: breathe 4s ease-in-out infinite;
              display: flex;
              align-items: center;
              gap: 1rem;
              /* On s'assure que l'animation ne bloque pas le curseur chenille */
              pointer-events: auto; 
            }

            .breathing-logo:hover {
              animation-duration: 1.5s; /* La respiration devient plus rapide (stressée/excitée) */
            }


    

          * {
            cursor: url(${moth}) 0 0, auto !important;
            a, 
            button, 
            [role="button"], 
            .cursor-pointer, 
            .cursor-pointer * { 
              cursor: url(${chenille}) 16 16, pointer !important;
            }
          }
        
          @keyframes fadeOut {
            0% { opacity: 1; }
            70% { opacity: 1; }
            100% { opacity: 0; }
          }

          

          @font-face {
          font-family: 'Flor de Ruina';
          src: url(${florRuina}) format('woff2');
          font-weight: normal;
          font-style: normal;
        }
        
        @font-face {
          font-family: 'Basteleur';
          src: url(${basteleurReg}) format('woff2');
          font-weight: normal;
          font-style: normal;
        }
        
        @font-face {
          font-family: 'Karrik';
          src: url(${karrikReg}) format('woff2');
          font-weight: normal;
          font-style: normal;
        }



          @font-face {
            font-family: 'Gensco';
            src: url(${genscoFont}) format('opentype');
            font-weight: normal;
            font-style: normal;
          }

          .gensco {
            font-family: 'Gensco', sans-serif;
            
          }
        
          .flor-de-ruina {
            font-family: 'Flor de Ruina', serif;
            font-weight: normal;
          }
        
          .basteleur {
            font-family: 'Basteleur', serif;
            font-weight: normal;
          }
        

          .karrik {
            font-family: 'Karrik', sans-serif;
            font-weight: normal;
            line-height: 1.4;
            letter-spacing: 0.02em; /* Un peu d'espace pour la lisibilité */
          }
      `}
      
      </style>


      {/* les anges */}   
      <img src={wings} className="tiny-floater img-1" alt="" onClick={handleWingClick} style={{ cursor: 'pointer', pointerEvents: 'auto' }} />
      <img src={wings2} className="tiny-floater img-2" alt="" onClick={handleWingClick} style={{ cursor: 'pointer', pointerEvents: 'auto' }} />
      <img src={wings} className="tiny-floater img-3" alt="" onClick={handleWingClick} style={{ cursor: 'pointer', pointerEvents: 'auto' }} />
      <img src={wings2} className="tiny-floater img-4" alt="" onClick={handleWingClick} style={{ cursor: 'pointer', pointerEvents: 'auto' }} />
        
    

      {/* Header */}
      <header className="fixed top-0 w-full bg-black z-40">
        <nav className="max-w-6xl mx-auto px-6 py-6 flex justify-between items-center flex-wrap gap-y-6">
  <div className="flex items-center gap-4">
    <div className="breathing-logo flex items-center gap-4">
      <img src={logo} alt="Logo" className="h-20 w-20 object-contain" />
      <h1 
        className="text-5xl flor-de-ruina tracking-wide cursor-pointer hover:opacity-80 transition-opacity"
        onClick={() => {
          playEvilSound(); 
          setShowSplash(true);
          setActiveSection('work');
        }}
      >
        Tâm Nguyen
      </h1>
    </div>
  </div>

  {/* La classe flex-wrap ici permet aux boutons de passer en dessous si l'écran est trop petit */}
  <div className="flex flex-wrap gap-8">
    <button
      onClick={() => setActiveSection('work')}
      className={`text-sm basteleur tracking-wider transition-colors ${
        activeSection === 'work' ? 'text-white' : 'text-gray-500'
      }`}
    >
      WORKS
    </button>

      {/* NOUVEAU BOUTON SCREENPLAY */}
  <button
    onClick={() => setActiveSection('screenplay')}
    className={`text-sm basteleur tracking-wider transition-colors ${
      activeSection === 'screenplay' ? 'text-white' : 'text-gray-500'
    }`}
  >
    MEGA MODERNE
  </button>


    <button
      onClick={() => setActiveSection('about')}
      className={`text-sm basteleur tracking-wider transition-colors ${
        activeSection === 'about' ? 'text-white' : 'text-gray-500'
      }`}
    >
      ABOUT/CV
    </button>
    <button
      onClick={() => setActiveSection('contact')}
      className={`text-sm basteleur tracking-wider transition-colors ${
        activeSection === 'contact' ? 'text-white' : 'text-gray-500'
      }`}
    >
      CONTACT
    </button>
  </div>
</nav>
      </header>
        
      {/* Contenu principal */}
      <main className="pt-24 pb-12 max-w-6xl mx-auto px-6">
        {/* Work Section */}
       {activeSection === 'work' && (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-16 animate-in fade-in duration-700">
    {projects.map((project) => (
      <div 
        key={project.id} 
        className="group cursor-pointer"
        onClick={() => setSelectedProject(project)}
      >
        <div className="bg-gray-900 mb-3">
  <img
    src={project.thumbnail}
    alt={project.title}
    className="w-full h-auto transition-opacity duration-500 group-hover:opacity-80"
  />
</div>

        {/* Infos sous l'image */}
        <div className="mt-4 space-y-1">
          <div className="flex justify-between items-baseline">
            <h3 className="karrik text-lg text-white group-hover:text-red-600 transition-colors">
              {project.title}
            </h3>
            <span className="basteleur text-xs text-gray-500">{project.year}</span>
          </div>
          <p className="karrik text-xs text-gray-500 uppercase tracking-widest opacity-60">
            {project.materials}
          </p>
        </div>
      </div>
    ))}
  </div>
)}


{/* Screenplay Section */}
{activeSection === 'screenplay' && (
  <div className="max-w-4xl mx-auto py-20 px-6 animate-in fade-in duration-1000">
    <div className="mb-16 text-center">
      <h2 className="text-4xl basteleur uppercase tracking-tighter mb-4">Méga Moderne</h2>
      <p className="karrik text-xs text-red-600 tracking-[0.2em] uppercase">Méga Moderne, tells the story of an obsolete Pikachu-robot slave inspired by my dad and my family history.  Ultimately, it is a story about being a working-class alien in an oppressive society, the depression of never finding your way or your space, and finally fighting for it.</p>
    

 <div className="mt-8 text-center">
      <p className="karrik text-gray-300 text-sm">
        have a read :{' '}
        <a
          href="/mega_moderne.pdf"
          download="mega_moderne.pdf"
          className="text-white hover:text-red-500 transition-colors underline"
        >
          mega_moderne.pdf
        </a>
      </p>
    </div>
    
    </div>



    {/* Le texte du scénario avec un style "Courier/Typewriter" pour l'authenticité */}
    <div className="bg-zinc-900/30 p-8 md:p-12 border border-white/5 rounded-sm shadow-2xl">
      <div className="max-w-2xl mx-auto space-y-6 text-gray-300 leading-relaxed font-mono text-sm md:text-base">
        
        <p className="text-white">
          <span className="font-bold text-red-500 uppercase mr-2">Daisy :</span> 
Mais c’est déjà ce qui arrive, tu as vu à quoi ça ressemble dehors? C’est un cimetière, des
familles entières se sont fait désactiver, des millions se déchargent lentement, c’est la panique, des
mouvements de protestations se créent en ce moment même, peut être à juste titre, vu comment on
les traite. On les a parqué dans des câbles comme des vulgaires fils de fer. Les infrastructures sont
pas entretenues, ça tombe en ruine, c’est insalubre, on découvre des cas de rouilles tous les jours.
En plus l’accord tacite entre les autorités et les dealers qui leurs permettent de vendre leurs merde
là, qui ramène de plus en plus d’ange dans les câbles, la cohabitation est extrêmement difficile.
C’est tout à fait normal que la colère monte. Les Pika-bots n’en peuvent plus, j’ai peur de ce qu’il
peut se passer.        </p>

        <p className="text-white">
T’as pas entendu parler du Pika-bot67? Il réunit de plus en plus d’abonnés. Il fait des danses qui
deviennent virales, des mukbang, des reviews, des podcasts, des analyses, des pranks mais ça c’est
la surface. J’ai entendu dire qu’il a été nommé Pika-god par le mouvement des tricots verts, le
mouvement de libération extrémiste cyberadical. Ils croient en lui, ils se réunissent autour de lui, ils
prient. Ils prient pour qu’ils les libèrent. Ils prient pour qu’ils les vengent, pour qu’ils les
rebranchent, qu’ils les réparent, qu’ils les upgrade. Ils utilisent un moyen de communication
complètement hermétique pour s’organiser sans qu’on puisse les surveiller, on dit qu’ils préparent
quelque chose. Peut être une guerre.        </p>

        <p className="italic text-gray-500 text-xs border-l border-gray-700 pl-4 py-1">
          Elle triture son collier de perles de Tahiti nerveusement.
        </p>

        <p className="text-white">
          <span className="font-bold text-red-500 uppercase mr-2">Picsou :</span> 
Il manquerait plus que ça, une guerre tribale. Moi je les massacre quand tu veux. Je les démembre, je les décapite, je les mets sur un piquet. Non mais tu sais c’est dans notre
sang, c’est primaire, on déteste les robots. C’est
comme une équipe de foot. Tu vas toujours soutenir ton équipe quoi qu’il arrive, même si t’es pas
dans le match. De toute façon à la belle époque on adorait ça les victimiser, les faire tourner en

bourrique, sentir leurs gemmes entre nos doigts. S’ils deviennent une menace, qu’on aille les
recycler alors, c’est ce que je te dis, j’vois pas le problème, ils rendent le paysage immonde, ils
défoncent nos câbles, des parasites comme ça, je te dis, soit on les concentre, soit on les déporte ou
on les extermine, ces putains de robots.        </p>

        <p className="text-white italic">
          <span className="font-bold text-red-500 uppercase mr-2 ">Daisy :</span> pas de R-word dans cette maison s’il te plaît.
        </p>

        <p className="italic text-gray-500 text-xs border-l border-gray-700 pl-4 py-1">
          Pika-bot s’arrête et se retourne vers Picsou, il à l’air choqué. Picsou baffe violemment le Pika-bot sur l’arrière de son crane, le robot vacille. L’impact créé une onde dans les bols de nouilles.
        </p>

        <p className="text-white">
          <span className="font-bold text-red-500 uppercase mr-2 ">Picsou :</span> Regarde il sent rien, c’est pas comme s’il allait s’évanouir hein ?
        </p>

        <p className="text-yellow-500 font-bold tracking-tighter">
          Pika-bot : pika pikarretestpcpassupercool
        </p>

        <p className="italic text-gray-500 text-xs border-l border-gray-700 pl-4 py-1">
          Daisy reste planté sur l’assise de sa chaise designer en cantilever... Ses doigts blanchissent sous la pression, le sang se coupe doucement, sa main s’anesthésie, ses ongles plantés dans le cadre en bois comme des fléchettes.
        </p>
 <p className="italic text-gray-500 text-xs border-l border-gray-700 pl-4 py-1">

  Picsou lui mets des balayettes, Pika-bot se relève, l’algorithme de stabilisation intégré lui donnant
assez de momentum pour se remettre en position debout, bien ancré au sol. Un front kick rageur est
asséné pile sur le cœur du Pika-bot. Il chancelle, c’est l’occasion parfait pour Picsou de lui met un
single-leg. La défense de lutte du Pika-bot laisse à désirer. Après un enchaînement bien senti, le
Pika-bot se retrouve au sol, allongé contre le lino collant.
 </p>
        <p className="text-white italic text-center py-4 opacity-50">
          [...]
        </p>

        <p className="italic text-gray-500 text-xs border-l border-gray-700 pl-4 py-1">
          Une odeur âcre, mélange de vieille poussière brûlant sur une résistance électrique, et de plastique chauffé se dégage du Pika-bot... Picsou re-rentre sa chemise en lin blanche tout en remontant son pantalon en velours cottelé. Il applaudit deux fois pour rallumer la lumière. Il se rassied sur la chaise, un peu honteux, mais aussi un peu fier de cette démonstration de force.
        </p>

      </div>
    </div>
  </div>
)}



        {/* About Section */}
        {activeSection === 'about' && (
  <main className="max-w-6xl mx-auto pt-32 pb-20 px-6 grid grid-cols-1 md:grid-cols-[1fr_1.3fr] gap-16 animate-in fade-in duration-1000 relative z-10">
    
    {/* COLONNE GAUCHE : Statement & Bio*/}
    <div className="md:sticky md:top-32 h-fit space-y-8">
      
      {/* Bio / About  */}
      <div className="karrik space-y-1 text-gray-400 text-base">
        <p></p>
        <p><span className="text-white">Tâm Nguyen</span> 1997</p>
        <p>il/lui</p>
        <p>Artiste Français - Vietnamien</p>
        <p>Vit et travaille à Bruxelles (BE)</p>
      </div>

      {/* Texte de Statement - Taille de police ajustée */}
      <div className="space-y-6">
        <h2 className="text-4xl basteleur uppercase tracking-tighter">Statement</h2>
<div className="space-y-4 text-gray-300 leading-relaxed karrik text-base">
  <p>
    My practice is a satirical dissection of power structures built through total installations where every object, sound, and image connects. It began with Wall of Noise, a series of paintings exploring overstimulating contemporary landscapes. Over the years, these paintings became the atmospheric study of a broader mythology, a world buried under a mountain of plastic, pixels, and nonsense.
</p>
<p>
From this foundation, I collect, fabricate, play, and trap, using pop seduction as a vehicle for postcolonial critique, techno-capitalist depression, and systemic violence. A vomiting fountain as a symbol of structural racism, a sigma male totem erecting toxic masculinity as a contemporary divinity. 
</p>
<p>
To build my installations, I am always on the lookout for waste to give new life to. These artifacts are cursed. By the spectres of a lost carefreeness, by a future full of false promises. This is where my research meets Mark Fisher’s hauntology<sup>1</sup>: these objects carry the weight of a future that never came. By intervening on them, I believe I put new emotions and belief in them. 
</p>
<p>
Once a byproduct of a failed system, now arguing against it.
</p>
<p>
One more layer to my process is speculative fiction writing, Méga Moderne, a screenplay staring an obsolete Pikachu-robot inspired by my working class immigrant dad. This text articulates meaning, generates theoretical directions. It is a a loop where the narrative triggers the work and the work rewrites the narrative. From that emerges fictional archaeologies that blur the line between playful and violent, found and made, precious and trash, luring the viewer in with colors and humor before the meaning strikes.
  </p>
  
  <div className="text-xs text-gray-500 mt-8 space-y-1">
    <p><sup>1</sup> Ghosts of my life, Mark Fisher, Entremonde, 2021</p>
  </div>
</div>      </div>
    </div>

    {/*  (Exhibitions & Education) --- */}
    <div className="space-y-12">
      
      {/* SECTION EXHIBITIONS  */}
      <section>
        <h2 className="text-2xl basteleur mb-6 uppercase tracking-tighter text-white/90">Exhibitions</h2>
        <div className="karrik space-y-3 text-sm">
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-red-600 text-base">2026</span>
            <div className="border-l border-red-900/30 pl-4">
            <p>L.Y.F.E., <span className="opacity-40 italic text-xs">Espace Vanderborght, Brussels</span></p>
            <p>Happy Painting, <span className="opacity-40 italic text-xs">Espace Vanderborght, Brussels</span></p>
              <p>Future matters, <span className="opacity-40 italic text-xs">EDJI Gallery, Brussels</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline pt-1">
            <span className="basteleur text-gray-500 text-base">2025</span>
            <div className="border-l border-gray-800 pl-4 space-y-1">
              <p>I’ll see you in my dreams, <span className="opacity-40 italic text-xs">Botanique Galerie + Serres, Brussels</span></p>
              <p>Einblick, Ausblick, <span className="opacity-40 italic text-xs">Muthesius Kunsthochschule, Kiel</span></p>
              <p>Monstrumz, <span className="opacity-40 italic text-xs">Künstlerhaus Bethanien, Berlin</span></p>
              <p>Wolfstöne, Dissonanzen und Geräusche, <span className="opacity-40 italic text-xs">Uferstudios, Berlin</span></p>
              <p>Zwei Einheiten, <span className="opacity-40 italic text-xs">FabrikStrasse, Kiel</span></p>
              <p>Amygdala, epicenter of fear, <span className="opacity-40 italic text-xs">ProjektRaum, Kiel</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline pt-1">
            <span className="basteleur text-gray-500 text-base">2024</span>
            <div className="border-l border-gray-800 pl-4 space-y-1">
              <p>Icy Patch, <span className="opacity-40 italic text-xs">L’imprimerie, Brussels</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline pt-1">
            <span className="basteleur text-gray-500 text-base">2022</span>
            <div className="border-l border-gray-800 pl-4 space-y-1">
              <p>Meme Meme, <span className="opacity-40 italic text-xs">Jacques Frank, Brussels</span></p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION EDUCATION */}
      <section>
        <h2 className="text-2xl basteleur mb-6 uppercase tracking-tighter text-white/90">Education</h2>
        <div className="karrik space-y-2 text-sm">
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-gray-500 text-[10px] uppercase">25-26</span>
            <div className="border-l border-gray-800 pl-4">
              <p>MFA. Fine Art, <span className="opacity-40 italic text-xs">Royal Academy of Fine Art, Brussels</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-gray-500 text-[10px]">24—25</span>
            <div className="border-l border-gray-800 pl-4">
              <p>MFA. Fine Art, <span className="opacity-40 italic text-xs">Muthesius Kunsthochschule, Kiel</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-gray-500 text-[10px]">22—24</span>
            <div className="border-l border-gray-800 pl-4">
              <p>BA. Fine Art, <span className="opacity-40 italic text-xs">Royal Academy of Fine Art, Brussels</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-gray-500 text-[10px]">21—22</span>
            <div className="border-l border-gray-800 pl-4">
              <p>BA. Fine Art, <span className="opacity-40 italic text-xs">Ecole de Recherche Graphique, Brussels</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-gray-500 text-[10px]">14—19</span>
            <div className="border-l border-gray-800 pl-4">
              <p>MSC. Computer Engineering, <span className="opacity-40 italic text-xs">Université de Technologie de Troyes</span></p>
            </div>
          </div>
        </div>
      </section>

       {/* SECTION PRIZES, PROGRAMS, RESIDENCIES */}
      <section>
        <h2 className="text-2xl basteleur mb-6 uppercase tracking-tighter text-white/90">Prizes, Programs, Residencies</h2>
        <div className="karrik space-y-2 text-sm">
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-red-600 text-[10px] uppercase">26-28</span>
            <div className="border-l border-red-900/30 pl-4">
              <p>Remote Frequencies, <span className="opacity-40 italic text-xs">Mutant Radio x Studio Néau, Brussels+Berlin</span></p>
            </div>
          </div>
          <div className="grid grid-cols-[60px_1fr] gap-2 items-baseline">
            <span className="basteleur text-gray-500 text-[10px]">25-26</span>
            <div className="border-l border-gray-800 pl-4">
              <p>Future Matters, <span className="opacity-40 italic text-xs">EDJI Gallery, Brussels</span></p>
            </div>
          </div>
          
          
        
        </div>
      </section>
    </div>
  </main>
)}






{/* Contact Section */}
{activeSection === 'contact' && (
  <div className="max-w-2xl mx-auto py-12 animate-in fade-in duration-700">

    <h2 className="text-5xl basteleur mb-8">Contact</h2>
    
    <div className="space-y-8">

      <div className="w-full py-4"> 
        <div className="relative group mx-auto">
          {/* L'effet de halo rouge */}
          <div className="absolute -inset-1 bg-gradient-to-r from-red-900 to-black rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
          
          <img 
            src={maPhoto} 
            alt="Tâm Nguyen" 
            className="relative rounded-lg grayscale hover:grayscale-0 transition-all duration-700 w-full h-auto object-cover border border-gray-800 shadow-xl"
          />
        </div>
      </div>

      {/* TEXTE Karrik */}
      <p className="text-lg text-gray-300 karrik leading-relaxed">
        Please contact me for any inquiries on my email. The link for any sound piece is in my soundcloud. I also play in a band with Alexe Françoise, called Silicon Balais. This is not a side project and is a musical translation of our artistic thoughts, the bandcamp link is also under there. Thank you for visiting this website.
      </p>

      {/* LIENS Sociaux */}
      <div className="flex flex-wrap gap-x-8 gap-y-4 pt-4">
        <a
          href="mailto:ngutam91@gmail.com"
          className="flex items-center gap-2 text-gray-300 hover:text-white transition-all"
        >
          <Mail size={18} />
          <span className="text-sm karrik tracking-widest uppercase">ngutam91@gmail.com</span>
        </a>

        <a
          href="https://instagram.com/tangurex/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-300 hover:text-white transition-all"
        >
          <Instagram size={18} />
          <span className="text-sm karrik tracking-widest uppercase">@tangurex</span>
        </a>

        <a
          href="https://soundcloud.com/tangurex"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-300 hover:text-white transition-all"
        >
          <Music size={18} />
          <span className="text-sm karrik tracking-widest uppercase">SoundCloud</span>
        </a>

        <a
          href="https://siliconbalais.bandcamp.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-300 hover:text-white transition-all"
        >
          <Disc3 size={18} />
          <span className="text-sm karrik tracking-widest uppercase">Bandcamp</span>
        </a>
      </div>
    </div>
  </div>
)}
      </main>

      {/* Lightbox - Page complète qui scroll */}
      {selectedProject && (
        <div
          className="fixed inset-0 bg-black z-50 overflow-y-auto"
          onClick={() => setSelectedProject(null)}
        >
          <button
            onClick={() => setSelectedProject(null)}
            className="fixed top-6 right-6 text-white hover:text-gray-400 transition-colors z-10"
          >
            <X size={32} />
          </button>
          
          <div className="min-h-screen py-12 px-6" onClick={(e) => e.stopPropagation()}>
            <div className="max-w-4xl mx-auto">
              {/* Informations du projet EN HAUT */}
              <div className="mb-12 pb-8 border-b border-gray-800">
                <h2 className="text-4xl karrik mb-4">{selectedProject.title}</h2>
                <div className="space-y-1 text-gray-400 text-sm">
                  <p>{selectedProject.year}</p>
                  <p>{selectedProject.dimensions}</p>
                  <p>{selectedProject.materials}</p>
                </div>
                {selectedProject.description && (
                  <p className="text-gray-300 leading-relaxed font-light mt-6">
                    {selectedProject.description}
                  </p>
                )}
              </div>

              {/* Images empilées verticalement */}
              <div className="space-y-8">
                {selectedProject.images.map((image, index) => (
                  <div key={index} className="w-full">
                    <img
                      src={image}
                      alt={`${selectedProject.title} - ${index + 1}`}
                      className="w-full h-auto"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      

      {/* Footer avec Crédits Typos */}
      <footer className="mt-20 py-10 border-t border-gray-900 bg-black">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-end gap-6">
          
          {/* Section gauche : Crédits */}
          <div className="flex flex-col gap-2">
            <h3 className="basteleur text-xs text-gray-500 uppercase tracking-widest mb-2">Typography Credits</h3>
            <ul className="text-[10px] space-y-1 text-gray-600 karrik uppercase tracking-tighter">
              <li><span className="text-gray-400">Flor de Ruina</span> — by Flor de Ruina</li>
              <li><span className="text-gray-400">Gensco</span> — by OpenType</li>
              <li><span className="text-gray-400">Basteleur</span> — by Keissel & Velvetyne</li>
              <li><span className="text-gray-400">Karrik</span> — by Jean-Baptiste Morizot</li>
            </ul>
          </div>

          {/* Section droite : Copyright ou info supplémentaire */}
          <div className="text-[10px] text-gray-700 basteleur uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Tâm Nguyen - Ceci est un site codé par moi même
          </div>
        </div>
      </footer>



      {/* Vue détaillée (Cocon) */}
{selectedProject && (
  <div className="fixed inset-0 z-[100] bg-black overflow-y-auto">
    {/* L'effet de tissage */}
    <div className="cocoon-overlay pointer-events-none"></div>

    <div className="project-content max-w-6xl mx-auto px-6 py-24 min-h-screen">
      {/* Bouton Fermer */}
      <button 
        onClick={() => setSelectedProject(null)}
        className="fixed top-8 right-8 z-[110] text-white hover:text-red-600 transition-colors"
      >
        <X size={40} />
      </button>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        {/* Images du projet */}
        <div className="space-y-8">
  {selectedProject.images.map((img, index) => (
    <img 
      key={index} 
      src={img} 
      className="w-full border border-white/5 transition-transform duration-1000" 
      alt="" 
      style={{ filter: 'none' }} // On s'assure que c'est bien en couleur ici aussi
    />
  ))}
</div>

        {/* Infos du projet */}
        <div className="md:sticky md:top-24 h-fit space-y-8">
          <div className="space-y-2">
            <h2 className="text-5xl basteleur leading-tight">{selectedProject.title}</h2>
            <p className="karrik text-xl text-red-600">{selectedProject.year}</p>
          </div>

          <div className="karrik space-y-6 text-gray-300 text-lg leading-relaxed">
            <div className="flex flex-col gap-1 border-l border-gray-800 pl-6 text-sm uppercase tracking-widest text-gray-500">
              <span>{selectedProject.materials}</span>
              <span>{selectedProject.dimensions}</span>
            </div>
            <p>{selectedProject.description}</p>
          </div>
        </div>
      </div>
    </div>
  
  
  </div>
)}












    </div>
  );
}

export default App;